var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 py-4 text-left md:px-4 xl:px-1.5 md:py-5"},[_c('WwReadMore',{on:{"is-expanded":_vm.setExpanded}},[_c('WwHtmlContent',{staticClass:"text-left",attrs:{"markup":_vm.introText,"expanded":_vm.expanded,"use-line-clamp":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }